import React, { useLayoutEffect } from "react";
import { HashRouter as Router, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import SiteNav from "./components/SiteNav";
import SiteFooter from "./components/SiteFooter";
import HomePage from "./components/HomePage";
import ResumePage from "./components/ResumePage";
import RouteEffects from "./components/RouteEffects";

function normalizePath(pathname) {
  const withSlash = pathname.startsWith("/") ? pathname : `/${pathname}`;
  if (withSlash === "/about" || withSlash === "/project") return "/";
  return withSlash;
}

function HashFix() {
  const location = useLocation();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    const path = location.pathname.startsWith("/")
      ? location.pathname
      : `/${location.pathname}`;
    if (path === "/about" || path === "/project") {
      navigate("/", { replace: true });
      return;
    }
    if (location.pathname.startsWith("/")) return;
    const name = location.pathname;
    if (name === "work" || name === "projects" || name === "resume") {
      navigate(`/${name}`, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

function AppFrame() {
  const { pathname: rawPath } = useLocation();
  const pathname = normalizePath(rawPath);
  const home = pathname === "/" || pathname === "/work" || pathname === "/projects";

  return (
    <div className={`site${pathname === "/resume" ? " is-resume" : ""}`}>
      <SiteNav />
      <RouteEffects />
      {home ? (
        <HomePage />
      ) : (
        <Routes>
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/about" element={<Navigate to="/" replace />} />
          <Route path="/project" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      )}
      <SiteFooter />
    </div>
  );
}

function App() {
  return (
    <Router>
      <HashFix />
      <AppFrame />
    </Router>
  );
}

export default App;
